import { Anchor, Card, PinInput, Text, Title } from "@mantine/core";
import { titleToUrl } from "@utils/routing";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useMainMetaMap } from "../../../../../../../app/components/CoreDataProvider";
import { TestFormats } from "../test-builder/components/Stepper/types";
import NonAttemptedTestsPlaceholder from "../test-builder/components/summaries/NonAttemptedTestsPlaceholder";
import { testIDPossibleCharacters } from "../test-taker/components/TestSearchInput";
import classes from "./TakeExistingTestPrompt.module.css";

export default function TakeExistingTestPrompt({
  subjectNameLower,
}: {
  subjectNameLower: string;
}) {
  const mainMetaMap = useMainMetaMap();
  const subjectDocumentId = Object.keys(mainMetaMap).find(
    (key) => mainMetaMap[key].title.toLowerCase() === subjectNameLower
  );
  const router = useRouter();
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder mt="7vw">
      <Card.Section p="lg" bg={"darkblue"} mb="lg">
        <Title order={3} c="white" size="1.4rem">
          Rather take an existing test?
        </Title>
      </Card.Section>
      <NonAttemptedTestsPlaceholder />
      <Text>
        To see previous tests you have taken, go to your{" "}
        <Anchor
          fw={500}
          component={Link}
          href={`/profile/performance?activeSubjectId=${subjectDocumentId}&activePerformanceType=tests`}
        >
          performance page
        </Anchor>
        , or take a new one by entering the access-code below.
      </Text>
      <Card.Section mt="lg">
        <PinInput
          p="lg"
          className={classes.pinInput}
          type={new RegExp(`[${testIDPossibleCharacters}]`)}
          length={8}
          onComplete={(value) => {
            router.push(
              `/ib/${titleToUrl(subjectNameLower)}/test-taker?testId=${value}`
            );
          }}
        />
      </Card.Section>
    </Card>
  );
}
